<template>
  <v-dialog
    fullscreen
    eager
    v-model="dialog"
    hide-overlay
    content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="closeDialog">
          <v-icon large color="primary">close</v-icon>
        </v-btn>
      </v-col>
      <v-container>
        <v-stepper v-model="currentStep">
          <v-stepper-header>
            <template v-for="n in steps">
              <v-stepper-step
                :key="`${n}-step`"
                :complete="currentStep > n"
                :step="n"
              >
                {{ stepHeader(n) }}
              </v-stepper-step>

              <v-divider
                v-if="n !== steps"
                :key="n"
              ></v-divider>
            </template>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content
              v-for="n in steps"
              :key="`${n}-content`"
              :step="n"
            >
              <div class="text-center">
                <v-btn
                  color="primary"
                  :disabled="isNextDisabled"
                  v-if="showNext"
                  @click="nextStep(n)"
                >
                  {{ nextButtonText }}
                </v-btn>
                <v-btn
                  @click="previousStep(n)"
                  text>
                  {{ previousButtonText }}
                </v-btn>
              </div>

            </v-stepper-content>
          </v-stepper-items>

          <v-stepper-items>
            <v-stepper-content
              v-for="n in steps"
              :key="`${n}-content`"
              :step="n"
            >
              <component
                :ref="`step-${n}`"
                :is="selectedComponent(n)"
                :loggedInCustomer="loggedInCustomer"
                @updateNextButton="(data) => {isAvailable = true; sendData = data;}"
                @updateStep1Model="(v) => (modelStep = v)"
                @emptyExcluded="emptyExcluded"
                @placeOffer="nextStep(n)"
              />
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import FirstStep from '@/modules/display/views/offer/create-campaign/FirstStep';
import SecondStep from '@/modules/display/views/offer/create-campaign/SecondStep';
import ThirdStep from '@/modules/display/views/offer/create-campaign/ThirdStep';
import OfferService from "@/modules/display/services/offer-service";
import CustomerService from '@/modules/core/services/customer-service';
import DataUtils from '@/modules/core/services/data-utils';
import Customer from '@/modules/core/data/customer';
import {Role} from "@/modules/core/data/roles";
import Utils from '@/modules/core/services/utils';

export default {
  name: "CreateCampaign",
  components: {
    FirstStep,
    SecondStep,
    ThirdStep
  },
  data() {
    return {
      loggedInCustomer: null,
      modelStep: null,
      dialog: false,
      steps: 3,
      currentStep: 1,
      isAvailable: false,
      sendData: null
    }
  },
  computed: {
    stepsLabel() {
      return [
        this.$t('display/offer:create.step.basic'),
        this.$t('display/offer:create.step.selection'),
        this.$t('display/offer:create.step.summary'),
      ];
    },
    showNext() {
      let showButton = true;
      if (this.currentStep === 3) {
        showButton = false;
      }

      return showButton;
    },
    nextButtonText() {
      let buttonText = this.$t('display/offer:create.step.next');
      if (this.currentStep === 3) {
        buttonText = this.$t('display/offer:create.step.place');
      }

      return buttonText;
    },
    previousButtonText() {
      let buttonText = this.$t('buttons:back');

      if (this.currentStep === 1) {
        buttonText = this.$t('buttons:close');
      }

      return buttonText;
    },
    isNextDisabled() {
      let isNext = true;

      if (this.currentStep === 1
        && this.modelStep != null
        && this.modelStep.category > 0) {
        isNext = false;
      } else if (this.currentStep === 2) {
        isNext = false;
      } else if (this.currentStep === 3 && this.isAvailable) {
        isNext = false;
      }

      return isNext;
    },
    isAdmin() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes(Role.Admin);
      }
      return false;
    },
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    initialization() {
      this.dialog = true;
      this.currentStep = 1;
    },
    selectedComponent(step) {
      let stepComponent = '';

      if (step === 1) {
        stepComponent = 'FirstStep';
      } else if (step === 2) {
        stepComponent = 'SecondStep';
      } else if (step === 3) {
        stepComponent = 'ThirdStep';
      }

      return stepComponent;
    },
    stepHeader(step) {
      let steps = this.stepsLabel;

      return steps[step - 1];
    },
    nextStep(n) {
      if (!this.$refs[`step-${this.currentStep}`][0].couldContinue()) return;

      if (n < this.steps) {
        this.currentStep = n + 1
      }

      if (this.currentStep === 3) {
        this.$refs['step-3'][0].setResults(
          Object.assign(
            this.$refs['step-2'][0].getModelValues(),
            {model: this.modelStep}
          )
        );
      }

      if (this.currentStep === 3 && this.isAvailable) {
        this.saveOffer();
      }
    },
    previousStep(n) {
      let currentStep = this.currentStep;
      if (n === 1) {
        this.closeDialog();
      } else {
        this.currentStep -= 1;
      }

      this.$refs['step-' + currentStep][0].previousStep();
      this.isAvailable = false;
    },
    closeDialog() {
      this.dialog = false;
      this.isAvailable = false;
      for(let i = 1; i <= this.steps; i++) {
        this.$refs[`step-${i}`][0].clear();
      }
    },
    emptyExcluded() {
      this.$refs['step-2'][0].clearExcludedElevator();
      this.previousStep(3);
    },
    saveOffer() {
      let sendData = Object.assign({}, this.sendData);

      if (!this.isAdmin) {
        sendData.provision = this.getProvisionByCustomer();
      } else if (sendData.provision > 0) {
        sendData.provision /= 100;
      }

      if (sendData.discount > 0) {
        sendData.discount /= 100;
      }

      OfferService.saveOffer(sendData,
        () => {
          Utils.showSuccessSnackbar(this.$t('snackbar:add-success', {name: this.$t('display/offer:overview.title')}));
          this.closeDialog();
          this.$emit('updateTable')
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:edit-failure', {name: this.$t('display/offer:overview.title')}))
        }
      )
    },
    getProvisionByCustomer() {
      let provision = 0;

      if (this.loggedInCustomer !== null && this.loggedInCustomer.provision !== null) {
        provision = this.loggedInCustomer.provision;
      }

      return provision;
    }
  },
  created() {
    CustomerService.readProfileFromAPI(
      (response) => {
        this.loggedInCustomer = DataUtils.parseDataToSingleObject(response.data, Customer);
      }
    );
  }
}
</script>


<style scoped>
/*
  had to set z-index of dialog and overlay manually here
  because here we have a single case of dialog over dialog
*/
.v-dialog__content.v-dialog__content--active {
  z-index: 450 !important;
}
</style>
